import { React, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { opcoesListaPacientes } from "../../utils/labels";
import { useNavigate } from "react-router-dom";
import { verificaPermissaoDeAcesso } from "../../services/permissoesDeAcesso";
import { getItemDecrypt } from "../../utils/cryptoData";

function RenderSwitch({ actionOptions, params }) {
  const navigate = useNavigate();
  async function handlePatientArea(pacienteId) {
    const vinculo = getItemDecrypt("vinculo_ativo");
    const response = await verificaPermissaoDeAcesso(pacienteId, vinculo.id);
    if (response) {
      navigate(`/pacientes/prontuario/${pacienteId}`);
    } else {
      navigate(`/pacientes/dados-paciente/${pacienteId}`);
    }
  }

  function handleEditRegister(pacienteId) {
    navigate(`/pacientes/detalhes-cadastro/${pacienteId}`);
  }

  function handleScheduleAppointment() {
    navigate(`/agendamentos`);
  }

  switch (actionOptions) {
    case opcoesListaPacientes.EM_ATRASO:
    case opcoesListaPacientes.EM_TRATAMENTO:
      return (
        <div key={1}>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
            }}
          >
            Agendar consulta
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
            }}
          >
            Visualizar prontuário
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
            }}
          >
            Finalizar alerta
          </MenuItem>
        </div>
      );
    case opcoesListaPacientes.CONSULTAS_DO_DIA:
      return (
        <div key={1}>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
            }}
          >
            Visualizar prontuário
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
            }}
          >
            Alterar agendamento
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
            }}
          >
            Agendar consulta
          </MenuItem>
        </div>
      );
    default:
      return (
        <div key={2}>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
              handlePatientArea(params.row.id);
            }}
          >
            Área do paciente
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
              handleEditRegister(params.row.id);
            }}
          >
            Editar cadastro
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.ignore = true;
              handleScheduleAppointment(params.row.id);
            }}
          >
            Agendar consulta
          </MenuItem>
        </div>
      );
  }
}

export default function Actions({ params, actionOptions }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreHoriz />
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <RenderSwitch actionOptions={actionOptions} params={params} />
      </Menu>
    </div>
  );
}
